import { Navigate, Outlet } from 'react-router-dom'
import { getLocalStorage } from '../utils/get-local-storage'
import { paths } from './paths'
import { SessionExpirationModal } from '../components/session-expiration-modal/SessionExpirationModal'

export const ProtectedRouter = () => {
  const token = getLocalStorage('token')
  const isLogged = sessionStorage.getItem('logged') === 'true'
  
  if (token && isLogged) {
    return (
      <>
        <SessionExpirationModal />
        <Outlet />
      </>
    )
  } else {
    return <Navigate to={paths.authentication.login} />
  }
}
